<template>
    <v-container>
        <v-card
          color="oug"
          class="pa-1 mx-auto text-center justify-center"
          max-width="600"
          elevation="24"
        >
        <v-card-title class="text-h6 white--text">
          My Connections
        </v-card-title>
            <v-card-text class="white--text"
              ><b
                >The following is a list of your Connections you are registered with and the Connections you have requested to join!</b
              ></v-card-text
            >
            <v-divider></v-divider>
            <v-tabs
                v-model="tab"
                color="orange accent-4"
                fixed-tabs
                >
                <v-tab
                    v-for="item in items"
                    :key="item.title"
                >
                    {{ item.title }}
                </v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
                <v-tab-item
                    v-for="item in items"
                    :key="item.title"
                >
                    <v-card flat class="pa-1">
                    <v-card-text 
                        class="pa-1 text-center"
                        v-for="(content, i) in item.content"
                        :key="i"
                    >
                    <v-row v-if="item.title === 'Current'" align="start">
                      <v-col align="start">
                          {{ content.Team }} - {{ content.Role }}
                      </v-col>
                      <v-col align="end">
                          <v-btn 
                            x-small
                            dark
                            color="red"
                            @click="ExitGroup(content)"
                          >
                            Remove from Entity
                          </v-btn>

                      </v-col>
                    </v-row>
                    <v-row v-if="item.title === 'Requested'" align="start">
                       <v-col align="start">
                          {{ content.Team }}
                      </v-col>
                      <v-col align="end">
                          <v-btn 
                            dark
                            x-small
                            color="red"
                            @click="CancelRequest(content)"
                          >
                            Cancel Request
                          </v-btn>

                      </v-col>
                    </v-row>
                    <v-row v-if="item.title === 'Others'" align="start">
                      <v-col align="start">
                        {{ content.Team }}
                      </v-col>
                      <v-col align="end">
                          <v-btn 
                            x-small
                            dark
                            color="blue"
                            @click="RequestToJoin(content)"
                          >
                            Request to Join
                          </v-btn>

                      </v-col>
                    </v-row>
                    <v-divider class="mt-2"></v-divider>
                    </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
            <div class="mt-2 text-sm-body-1" v-if="this.items == 0">
              <v-container>
              <p align="center" class="white--text">
                You not connected to any Entities at Present
              </p>
              </v-container>
            </div>
            <v-dialog
              v-model="addConnection"
              max-width="600px"
            >
              <v-card class="mt-3">
                <v-card-text>
                  <v-card-title>
                    <v-col cols="12">
                      {{RequestTitle}}
                    </v-col>
                    <v-col cols="12">
                      <h4>
                        {{selectedContent.Team}}?
                      </h4>
                    </v-col>
                  </v-card-title>
                  <v-divider></v-divider>
                </v-card-text>
                <v-card-actions>
                  <v-btn
                    color="oug"
                    text
                    @click="addConnection=false"
                  >
                    Cancel
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="oug"
                    outlined
                    @click="SendRequest(selectedContent)"
                  >
                    Yes
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
        </v-card>
    </v-container>
</template>

<script>
import { authComputed, getUser } from "../veux/helpers";

export default {
    data: () => ({
      addConnection: false,
      tab: null,
      items: JSON.parse(localStorage.getItem("Connections")),
      selectedContent: {},
      RequestTitle: ''
    }),
  created() {
    },
  methods: {
    RequestToJoin(content) {
      this.selectedContent = content
      this.RequestTitle = 'Send a request to join:'
      this.addConnection=true
    },
    async SendRequest(content) {
      // If already a member so remove me
      if (content.Member > 0) {
        this.addConnection = false
        this.$toast.info( `We are processing your request to leave ${content.Team}!`, {  timeout: 3000 })
        await this.$store.dispatch("reloadTeams", { Contact: JSON.parse(localStorage.getItem("Coach")).contact, ID: content.Member })
        this.items = JSON.parse(localStorage.getItem("Connections"))
        return
      } 
      // If already requested to join
      if (content.Invite > 0) {
        this.addConnection = false
        this.$toast.info( `We are processing your request to cancel your request to join ${content.Team}!`, {  timeout: 3000 })
        await this.$store.dispatch("reloadTeams", { Contact: JSON.parse(localStorage.getItem("Coach")).contact, ID: content.Invite })
        this.items = JSON.parse(localStorage.getItem("Connections"))
        return
      } 
      // Otherwise process a request
      this.addConnection = false
      this.$toast.info( `We are processing your request to join ${content.Team}!`, {  timeout: 3000 })
      await this.$store.dispatch("teamInvite", { Contact: JSON.parse(localStorage.getItem("Coach")).contact, Team: content.Slave_code_id, Role: 3, Auto: content.Auto })
      this.items = JSON.parse(localStorage.getItem("Connections"))
    },
    CancelRequest(content) {
      this.selectedContent = content
      this.RequestTitle = 'Cancel your request to join:'
      this.addConnection=true
    },
    ExitGroup(content) {
      this.selectedContent = content
      this.RequestTitle = 'Remove yourself from:'
      this.addConnection=true
    }

  },
  computed: {
      ...authComputed,
      ...getUser,
  },
};
</script>

<style lang="scss" scoped>

</style>